import React, { useState, useEffect, useCallback } from 'react'
import {Items, WrapperCutationEstimate} from "./item.style";
import { useSelector, useDispatch } from 'react-redux'
import { SET_SELECTED_FILTER, SET_ITEM_MORE_VIEW } from 'estimate_list/reducers/initial'
import { numberFormat, itemThumbUrl, filterTheorem } from 'estimate_list/libs/util'
import AddCompare from 'estimate_list/components/buttons/addCompare'
import Comparison from './item_comparison'
import ItemBrandView from './item_brand_view'
import Label from './item_label'
import InfoList from './item_info_list'
import MallArea from './item_mall_area'
import Thumb from '../layout/thumb'
import Report from 'estimate_list/utils/report'
import Zzim from './zzim'
import BundleGroup from "./bundleGroup/bundleGroup.container";
import ThumbLabelContainer from "./thumb_label/thumb_label.container";
// import styled from "styled-components";

const Item = ({ data, fixMode = false, like = '', curationIndex = null, gaEvent = null, adInfo = null}) => {
    const { f_sellout, price, seller, cnt_stock } = data
    const { domain, selectedFilters, minishopInfo, route, lists } = useSelector(state => state.initial)
    const [mode, setMode] = useState('list') // list, thumb
    const isSoldOut = f_sellout === 1 || f_sellout === 11 || price === 0 || !seller || cnt_stock === 0 // 일시품절 로직
    const isAdult = data.cate_f_adult && !data.user_f_adult // 성인인증 썸네일 사용여부
    const itemLink = `${process.env.REACT_APP_SHOPPING_URL}/detail/${data.item_id}${minishopInfo ? `/${minishopInfo.pr_idx}` : ''}`

    const dispatch = useDispatch()

    useEffect(() => {
        if (fixMode === 'list') {
            setMode('list')
        } else if (fixMode === 'thumb') {
            setMode('thumb')
        } else {
            setMode(route.types)
        }
    }, [route.types]) // eslint-disable-line

    const onClickSpec = useCallback(spec => () => {
        // ex) specNameKey:37, specValueKey: 12345, specValue: '상품분류 : 인텔 CPU용'
        const { specNameKey, specValueKey, specValue } = spec
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'spec',
                value: { specNameKey, specValueKey, specValue: specValue }
            })
        })
    }, [dispatch, selectedFilters])

    const active = useCallback(({ specNameKey, specValueKey }) => {
        const selectNameKey = selectedFilters.spec[specNameKey]
        if (selectNameKey) {
            const index = selectNameKey.findIndex(v => v.specValueKey === specValueKey)
            return index > -1
        }
    }, [selectedFilters.spec])

    const priceValue = (f_sellout, price, cnt_stock, seller) => {
        if (f_sellout === 2 || f_sellout === 12) {
            return <span className="no_price">{domain === 'minishop' ? '-' : '단종된 상품'}</span>
        } else if (f_sellout === 1 || f_sellout === 11 || price === 0 || !seller) {
            return <span className="no_price">{domain === 'minishop' ? '일시품절' : '가격비교예정'}</span>
        } else if  (cnt_stock === 0) {
            return <span className="no_price">일시품절</span>
        } else if (isPrice(f_sellout, price, cnt_stock, seller)) {
            return <>
                {domain !== 'minishop' && <span>최저 </span>}
                <span className="num">{numberFormat(price)}</span>
                <span>원</span>
            </>
        }
    }


    // const priceValueCuration = (f_sellout, price, cnt_stock, seller) => {
    //     if (f_sellout === 2 || f_sellout === 12) {
    //         return <span >{domain === 'minishop' ? '-' : '단종된 상품'}</span>
    //     } else if (f_sellout === 1 || f_sellout === 11 || price === 0 || !seller) {
    //         return <span >{domain === 'minishop' ? '일시품절' : '가격비교예정'}</span>
    //     } else if  (cnt_stock === 0) {
    //         return <span >일시품절</span>
    //     } else if (isPrice(f_sellout, price, cnt_stock, seller)) {
    //         return <>
    //             {domain !== 'minishop' && <CurationPriceText>최저 </CurationPriceText>}
    //             <CurationPrice>{numberFormat(price)}</CurationPrice>
    //             <CurationPriceText>원</CurationPriceText>
    //         </>
    //     }
    // }

    const isPrice = (f_sellout, price, cnt_stock, seller) => {
        return f_sellout === 0 && cnt_stock > 0 && price !== 0 && seller !== 0
    }

    const regExpEscape = (literal_string) => {
        return literal_string.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&');
    }

    const highlightTitle = useCallback(txt => {
        if (txt === undefined) return false
        const onTxt = selectedFilters?.kwd
        if (!onTxt) return txt

        const parts = txt.split(new RegExp(`(${regExpEscape(onTxt)})`, 'gi'))
        return parts.map((part, i) => part.toLowerCase() === onTxt.toLowerCase() ? <b key={i} className="highlight">{part}</b> : part)
    }, [selectedFilters])

    const moreView = id => {
        dispatch({
            type: SET_ITEM_MORE_VIEW,
            data: {id, like, curationIndex}
        })
    }

    const linkClick = () => {
        if (gaEvent && adInfo) {
            gaEvent(data, adInfo)
        } else if (gaEvent) {
            gaEvent(data)
        }
    }

    const comparisonStyle = {
        buttonStyle : `
        box-sizing: border-box;
        display : flex;
        flex-direction: row;
        align-items: center;
        white-space: nowrap;
        padding: 0 9px;
        margin: 0 0 0 1px;
        height: 27px;
        align-items: center;
        border: 1px solid transparent;
        z-index: 2;`,
        checkBoxStyle :{
            width : 16,
            height : 16,
            activeFontSize :15,
        },
    }

    /**
     * pc 견적 curation의 견적 담기 버튼 스타일
     * @type {{position: string, button_top: number, hoverWidth: number}}
     */

    const addEstimateStyle = {
        // button_top: 0,
        button_right : -81,
        hoverWidth : 109,
        position : 'absolute',
        estimate_add_btn_top : 1,
    }

    const returnCateLink = (domain, cate_id, mall_web_user) => {
        switch (domain){
            case 'pc':
                return `${process.env.REACT_APP_PC_URL}/list/${cate_id}`
            case 'shopping':
                return `${process.env.REACT_APP_SHOPPING_URL}/list/${cate_id}`
            case 'minishop':
                return `${process.env.REACT_APP_MINISHOP_URL}/${mall_web_user}/list/${cate_id}`
            case 'notebook' :
                return `${process.env.REACT_APP_NOTEBOOK_URL}/list/${cate_id}`
            default:
                return
        }
    }

    const curationPriceStyle = {width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}

    return (
        <Items className={`item ${domain !== 'shopping' ? 'pc' : ''} ${mode === 'thumb' ? 'thumb' : 'list'}`} domain={domain}>
            <div className="inner">
                <div className="img_area">
                    <div className="thumbnail_thumb_wrap">
                        <a href={itemLink} className="thumbnail_thumb" target="_blank" rel="noopener noreferrer" onClick={linkClick}>
                            <Thumb
                                src={itemThumbUrl(data.item_id, mode === 'thumb' ? 300 : 140)}
                                width="142"
                                height="142"
                                alt={data.full_item_name}
                                isAdult={isAdult}
                                domain={domain}
                            />
                        </a>
                    </div>
                    {like !== 'curation' && <ThumbLabelContainer thumb_label={data.thumb_label}/>}
                </div>
                <div className="info_area">
                    <Label data={data} />
                    <div className="title">
                        <a href={itemLink} className="link" target="_blank" rel="noopener noreferrer" onClick={linkClick}>
                            {highlightTitle(data.full_item_name)}
                        </a>
                    </div>
                    <div className="layout_trans">
                        <div className="price_area" style={ like === 'curation' ? curationPriceStyle : {}}>
                            <div className="price">
                                {
                                    // 2022-08-02 현금가(전체 최저가), 카드가(카드 최저가) 노출되게 수정 route.type
                                    priceValue(data.f_sellout, route.type === 'card' ? data.price_low_card : data.price, data.cnt_stock, data.cnt_firm, domain)
                                }
                            </div>
                            {domain === 'shopping' && (
                                data?.cnt_firm > 0 &&
                                <>
                                    <a href={itemLink} className="link" target="_blank" rel="noopener noreferrer">
                                        판매처 {data.cnt_firm || 0}
                                    </a>
                                    {(data.bundle_list?.length < 2 || adInfo) &&
                                        <Comparison data={data} comparisonStyle={comparisonStyle}/>
                                    }
                                </>
                            )}

                            {domain === 'pc' && like === 'curation' &&
                                <WrapperCutationEstimate>
                                    <AddCompare
                                        size={27}
                                        item={data}
                                        addCompareStyle={addEstimateStyle}
                                        cnt_firm_b2={data.cnt_firm_b2}
                                    />
                                </WrapperCutationEstimate>
                            }

                            {domain === 'minishop' && (
                                (data.nm_ad === 'P_견적_애드리스트SA' || adInfo !== null || data.bundle_list?.length === 0) &&
                                <div
                                    className={`estimate_group_btns ${isSoldOut ? 'sold_out': !(isPrice(data.f_sellout, data.price, data.cnt_stock, data.seller)) ? 'small' :
                                        lists.itemList?.isCompare === 0 ? 'compare' : ''}`} // 상품비교 안되는 상품의 경우 compare
                                >
                                    {(isPrice(data.f_sellout, data.price, data.cnt_stock, data.seller)) && (
                                        <AddCompare size={27} item={data} cnt_firm_b2={data.cnt_firm_b2}/>
                                    )}
                                    {/*<span className={`mall_count ${isSoldOut ? 'sold_out' : ''}`}>{data.market_real_count}몰111</span>*/}
                                    <Comparison data={data}/>
                                </div>
                            )}

                            {domain === 'pc' && (
                                (data.nm_ad === 'P_견적_애드리스트SA' || adInfo !== null || data.bundle_list?.length < 2) &&
                                <div
                                    className={`estimate_group_btns ${!(isPrice(data.f_sellout, data.price, data.cnt_stock, data.cnt_firm_est)) ? 'small' :
                                        lists.itemList?.isCompare === 0 ? 'compare' : ''}`} // 상품비교 안되는 상품의 경우 compare
                                >
                                    {(isPrice(data.f_sellout, data.price, data.cnt_stock, data.cnt_firm_est)) && (
                                        <AddCompare size={27} item={data} cnt_firm_b2={data.cnt_firm_b2}/>
                                    )}

                                    {(isPrice(data.f_sellout, data.price, data.cnt_stock, data.cnt_firm_est)) && (
                                        <>
                                            {/*<span className={'mall_count'}>{data.market_real_count}몰222</span>*/}
                                            <Comparison data={data}/>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="layout_trans2">
                            <div className="depth" >
                                <a href={returnCateLink(domain, data.cate_id, minishopInfo?.mall_web_user)} rel="noopener noreferrer">
                                    {data.category.map(v => (
                                        <span className="category" key={v.cate_id}>{v.cate_name}</span>
                                    ))}
                                </a>
                            </div>
                            {mode === 'list' && <ItemBrandView data={data} />}
                        </div>
                    </div>
                    {(data?.item_br_info?.length > 0 && mode === 'list') && (
                        <div className="desc">
                            <div className="detail_box">
                                {data.item_br_info.map((spec,index) => (
                                    <button
                                        key={`${index}${spec.specValueKey}`}
                                        className={`detail ${active(spec) ? 'active' : ''}`}
                                        onClick={onClickSpec(spec)}
                                    >
                                        {spec.specValue}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className="subinfo">
                        {/* <div className="special">행쇼 TIP. 회원가입 하면 5% 할인 이벤트</div> */}
                        {/* f_stdpc 1, 2 분기 추가 */}
                        {(data?.stdpc_list?.filter((v) => v.f_stdpc === 1).length > 0 && mode === 'list') && (
                            <InfoList title='행쇼 표준PC' data={data.stdpc_list.filter((v) => v.f_stdpc === 1)} type="stdpc" />
                        )}
                        {(data?.stdpc_list?.filter((v) => v.f_stdpc === 2).length > 0 && mode === 'list') && (
                            <InfoList title='행쇼 조립PC' data={data.stdpc_list.filter((v) => v.f_stdpc === 2)} type="stdpc" />
                        )}
                        {(data?.event?.length > 0 && mode === 'list') && (
                            <InfoList title='이벤트' data={data.event} type="event" />
                        )}
                    </div>
                    <div className="etc_box">
                        <span className="etc">
                            상품평
                            <span className="graph">
                                <span className="star" style={{ width: `${data.marks * 20}%` }}>
                                    별점 {data.marks}
                                </span>
                            </span>
                            <em className="num">{data.reviewsCount}</em>
                        </span>
                        <span className="etc">
                            출시일 {data.date_launch}
                        </span>


                        {mode === 'list' && (
                            <>
                                <span className="etc">
                                    <Zzim
                                        f_div={4}
                                        idx={data.item_id}
                                        selected={data.zzim_my > 0 ? true : false}
                                        count={data.cntZzim}
                                    >
                                        <span id={`item_${data.item_id}`}>
                                            <i className="icon-favorite_border" />
                                            찜하기
                                        </span>
                                        <span id={`item_zzim_${data.item_id}`}>{data.cntZzim}</span>
                                    </Zzim>
                                </span>
                                <span className="etc">
                                    <Report
                                        item={data.item_id}
                                        miniShop={minishopInfo
                                            ? {
                                                idx_b_manager: minishopInfo.idx_b_manager,
                                                mall_name: minishopInfo.mall_name,
                                            }
                                            : false
                                        }
                                        cls={'btn_report'}
                                        txt={'신고하기'}
                                    />
                                </span>
                            </>
                        )}
                    </div>
                </div>
                {(domain === 'shopping' && mode === 'list') && <MallArea data={data} />}
            </div>
            {route.types === 'list' && (data.nm_ad !=='P_견적_애드리스트SA' && data.bundle_list?.length > 1 && <BundleGroup data={data}/>)}
            {/*{ data.nm_ad !=='P_견적_애드리스트SA' && data.bundle_list?.length > 1 && <BundleGroup data={data}/>}*/}

            {mode === 'thumb' && (
                <div className="thumb_under_btn">
                    {data?.item_br_info?.length > 0 && (
                        <button
                            type="button"
                            onClick={() => moreView(data.item_id)} className={data.moreView ? 'button more active' : 'button more'}
                        >
                            더 보기 <i className={`icon-${data.moreView ? 'remove' : 'add'}`} />
                        </button>
                    )}
                    <Zzim
                        f_div={4}
                        idx={data.item_id}
                        selected={data.zzim_my > 0 ? true : false}
                        count={data.cntZzim}
                    >
                        찜하기 <i className="icon-favorite_border" />
                    </Zzim>
                </div>
            )}
            {/* <InfoOption /> 현재 미사용*/}
        </Items>
    )
}

export default Item

// const WrapperCurationPriceArea = styled.div`
//     display: flex;
//     flex-direction: row;
//     justify-content: right;
//     align-items: flex-end;
//     width: 100%;
//     box-sizing: border-box;
// `
//
// const CurationPriceText = styled.span`
//     color: #666;
//     font-size: 16px;
// `
//
// const CurationPrice = styled.span`
//     color: #f24443;
//     font-weight: 700;
//     font-size: 26px;
// `





// WEBPACK FOOTER //
// ./src/estimate_list/components/list/item.js